<div class="step-content">
  <div class="usecase-editor-modal">
    <!-- Header with Add/Edit Button -->
    <div class="usecase-editor-modal__header">
      <h3 class="usecase-editor-modal__title">Build Your Usecase</h3>
      <button 
        type="button" 
        class="btn-add-section"
        (click)="openAddModal()"
      >
        <svg *ngIf="sections.length === 0" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 1V15M1 8H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <svg *ngIf="sections.length > 0" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M11.333 2.00004C11.5084 1.82463 11.7163 1.68648 11.9451 1.59347C12.1738 1.50046 12.4191 1.45435 12.6663 1.45435C12.9135 1.45435 13.1588 1.50046 13.3876 1.59347C13.6163 1.68648 13.8242 1.82463 13.9997 2.00004C14.1751 2.17545 14.3132 2.38334 14.4062 2.61208C14.4992 2.84082 14.5454 3.08615 14.5454 3.33337C14.5454 3.5806 14.4992 3.82593 14.4062 4.05467C14.3132 4.28341 14.1751 4.4913 13.9997 4.66671L5.33301 13.3334L1.33301 14.6667L2.66634 10.6667L11.333 2.00004Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ sections.length > 0 ? 'Edit Content' : 'Add Content' }}
      </button>
    </div>

    <!-- Preview Area -->
    <div class="usecase-editor-modal__preview" #previewContainer>
      <div *ngIf="sections.length > 0" class="preview-sections">
        <div *ngFor="let section of sections; let i = index" class="preview-section">
          <div class="preview-section__content">
            <div class="preview-section__description" [innerHTML]="section.description"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Validation Error -->
    <span *ngIf="hasError('sections')" class="error-message">{{ getError('sections') }}</span>
  </div>
</div>

<!-- Modal for Add/Edit Content -->
<app-modal
  [(visible)]="showModal"
  [header]="editingSection ? 'Edit Content' : 'Add Content'"
  [width]="'800px'"
  [confirmLabel]="'Save Content'"
  [cancelLabel]="'Cancel'"
  [confirmButtonDisabled]="!canSaveContent"
  (onConfirm)="saveSection()"
  (onCancel)="closeModal()"
>
  <!-- PrimeNG Editor -->
  <div class="modal-editor">
    <!-- Format Guide accordion -->
    <div class="format-guide-callout">
      <div
        class="format-guide-header"
        role="button"
        tabindex="0"
        (click)="toggleFormatGuide()"
        (keydown.enter)="toggleFormatGuide()"
        (keydown.space)="toggleFormatGuide(); $event.preventDefault()"
        [attr.aria-expanded]="formatGuideExpanded"
      >
        <span class="format-guide-title">Format Guide</span>
        <svg
          class="format-guide-caret"
          [class.format-guide-caret--open]="formatGuideExpanded"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="format-guide-content" *ngIf="formatGuideExpanded">
        <div class="format-guide-mapping">
          <span>1. Title – Heading 2</span>
          <span class="format-guide-sep">|</span>
          <span>2. Subtitle – Heading 3</span>
          <span class="format-guide-sep">|</span>
          <span>3. Paragraph – Normal</span>
        </div>
        <div class="format-visual-example">
          <div class="format-example-label">Example:</div>
          <div class="format-visual-content">
            <div class="format-visual-row">
              <span class="format-visual-text format-visual-h2">{{ formatExamples.h2a }}</span>
              <span class="format-visual-badge format-badge-h2">Title</span>
            </div>
            <div class="format-visual-row">
              <span class="format-visual-text format-visual-p">{{ formatExamples.para }}</span>
              <span class="format-visual-badge format-badge-p">Paragraph</span>
            </div>
            <div class="format-visual-row">
              <span class="format-visual-text format-visual-h2 format-visual-h2--smaller">{{ formatExamples.h2b }}</span>
              <span class="format-visual-badge format-badge-h2">Title</span>
            </div>
            <div class="format-visual-row">
              <span class="format-visual-text format-visual-h3">{{ formatExamples.h3 }}</span>
              <span class="format-visual-badge format-badge-h3">Subtitle</span>
            </div>
            <div class="format-visual-row">
              <span class="format-visual-text format-visual-bullet">• {{ formatExamples.bullet }}</span>
              <span class="format-visual-badge format-badge-p">Paragraph</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="editor-wrapper" (click)="formatGuideExpanded = false">
      <p-editor
        [(ngModel)]="modalSection.description"
        [style]="{'height': '220px'}"
        [modules]="editorConfig.modules"
        (onTextChange)="onEditorTextChange($event)"
        (onInit)="onEditorInit($event)"
      ></p-editor>
    </div>

    <!-- Option 1: Updated Tip with heading guidance -->
    <div class="editor-hint">
      <span>Tip: Paste content directly - formatting (bold, bullets, headings) will be preserved. Use toolbar for formatting.</span>
    </div>

    <div class="editor-note">
      <span>Note: At least one Title and one Paragraph should be present.</span>
    </div>

    <!-- Editor Format Flaws (shown only on Save click) -->
    <div *ngIf="editorFormatFlaws.length > 0" class="editor-validation-error" #validationError>
      <div class="error-icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="currentColor" stroke-width="2"/>
          <path d="M10 6V10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M10 14H10.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="error-content">
        <div class="error-message-text">Format issues found. Please fix the following:</div>
        <ul class="format-flaws-list">
          <li *ngFor="let flaw of editorFormatFlaws" class="format-flaw-item">
            <span class="format-flaw-element">Block {{ flaw.index + 1 }}: {{ flaw.element }}</span>
            <span class="format-flaw-message">– {{ flaw.message }}</span>
          </li>
        </ul>
        <div class="format-guidance">
          <div class="format-guidance-title">Allowed Formats:</div>
          <div class="format-examples">
            <div class="format-example">
              <div class="format-label">Format 1: Title + Paragraph</div>
              <div class="format-structure">
                <span class="format-element format-title">Title (Heading 2)</span>
                <span class="format-arrow">↓</span>
                <span class="format-element format-description">Paragraph (Normal)</span>
              </div>
            </div>
            <div class="format-example">
              <div class="format-label">Format 2: Title + Subtitle + Points</div>
              <div class="format-structure">
                <span class="format-element format-title">Title (Heading 2)</span>
                <span class="format-arrow">↓</span>
                <span class="format-element format-subsection">Subtitle (Heading 3)</span>
                <span class="format-arrow">↓</span>
                <span class="format-element format-points">Paragraph (Bullets)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>
